// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vzze","right":"styles_right__1U9Gv"};